import mapFunction from './mapResources';

export default mapFunction('employee_trainings', {
    isFetching: false,
    items: [] 
});
